import * as R from 'ramda';

const library = require('@safe-systems/ss-ui-components');

const { copy } = library;

export default function TrainingAdminEditMediaDialogController(
  $q,
  $scope,

  ssDialogService,
  alerts,
  loaderService,
  eduDataService
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleSelectMediaTypeClick = _handleSelectMediaTypeClick;
  vm.handleEditMediaSubmit = _handleEditMediaSubmit;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.newMediaInputs = angular.copy(vm.media);
    if (!vm.newMediaInputs.mediaTypeId) {
      vm.newMediaInputs.mediaTypeId = 1;
    }
    // setTimeout(_handleSelectMediaTypeClick(vm.newMediaInputs.mediaTypeId),500);
  }

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.admin.editTrainingMediaDialog);
  }

  function _handleSelectMediaTypeClick(mediaTypeId) {
    console.log(`vm._handleSelectMediaTypeClick mediaTypeId:${mediaTypeId}`);
    vm.newMediaInputs.mediaTypeId = mediaTypeId;
    $scope.editMediaForm.$setPristine();
  }

  function _handleEditMediaSubmit() {
    if ($scope.editMediaForm.$valid) {
      loaderService.showViewLoader = true;
      const media = {
        mediaId: vm.newMediaInputs.mediaId,
        name: vm.newMediaInputs.name,
        description: vm.newMediaInputs.description,
        keywords: vm.newMediaInputs.keywords,
        mediaTypeId: vm.newMediaInputs.mediaTypeId,
        contentId: vm.newMediaInputs.contentId,
        fileName: vm.newMediaInputs.fileName,
      };

      _saveMedia(media);
    }
  }

  function _saveMedia(media) {
    const thumbnail = '';
    const files = [];
    if (vm.newMediaInputs.mediaTypeId === 1) {
      // / Media is a document
      if (!R.isNil(vm.newMediaInputs.documentFile)) {
        files.push(vm.newMediaInputs.documentFile);
      }
    } else if (vm.newMediaInputs.mediaTypeId === 3) {
      // Media is a presentation
      if (!R.isNil(vm.newMediaInputs.presentationFile)) {
        files.push(vm.newMediaInputs.presentationFile);
      }
      media.thumbnailUrl = vm.newMediaInputs.thumbnailUrl;
    } else {
      // Webinar
      media.thumbnailUrl = vm.newMediaInputs.thumbnailUrl;
      media.mediaUrl = vm.newMediaInputs.mediaUrl;
    }

    // Save Media
    eduDataService.saveMedia(vm.section.sectionId, media, thumbnail, files)
      .then((response) => {
        // Upload successful
        _handleSaveMediaSuccess(response);
        alerts.success(
          copy.admin.trainingAdministration.alerts.uploadPresentationSuccessful.text
        );
      },
      (response) => {
        // Upload failed
        console.log(response);
      },
      (event) => {
        // Upload progress
        // TODO: Check to see how this works if presentation AND thumbnail are both uploaded
        if (vm.newMediaInputs.mediaTypeId === 1) {
          // / Media is a document
          if (vm.newMediaInputs.documentFile) {
            vm.newMediaInputs.documentFile.progress = parseInt(100.0 * event.loaded / event.total, 10);
          }
        } else if (vm.newMediaInputs.mediaTypeId === 3) {
          // Media is a presentation
          if (vm.newMediaInputs.presentationFile) {
            vm.newMediaInputs.presentationFile.progress = parseInt(100.0 * event.loaded / event.total, 10);
          }
        } else {
          // Webinar
        }
      });
  }


  function _handleSaveMediaSuccess(response) {
    const newMedia = response.data;
    if (!vm.newMediaInputs.mediaId) {
      // Media is new
      vm.section.medias = R.sortBy(
        R.prop('sortOrder'),
        R.append(
          newMedia,
          vm.section.medias
        )
      );
    } else {
      // Media already existed

      vm.section.medias[R.indexOf(
        vm.media,
        vm.section.medias
      )] = newMedia;

      vm.media = newMedia;
    }

    loaderService.showViewLoader = false;
    ssDialogService.hide(ssDialogService.dialogs.admin.editTrainingMediaDialog);
  }
}

TrainingAdminEditMediaDialogController.$inject = [
  '$q',
  '$scope',

  'ssDialogService',
  'alerts',
  'loaderService',
  'eduDataService',
];
